var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayLogo)?_c('v-div',{staticClass:"SmallPartnerLogo",attrs:{"layer-2":"","ml-2":"","pl-2":"","width-96":"","height-32":""}},[(_vm.smallLogo)?_c('img',{attrs:{"src":_vm.smallLogo,"alt":`by ${_vm.sourcePartnerName}`}}):_c('v-div',{attrs:{"float-right":"","caption":""}},[_vm._v(_vm._s(_vm.origin))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }